import React, { useRef, useState, useMemo, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import { getDrivers, fetchSavedView, baseUrl  } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import { Button, Grid } from '@mui/material';
import ModalComponent from '../../common/Modal/ModalComponent';
import Spinner2 from '../../common/Spinner/Spinner2';
import ResourceDetails from '../../../../shared/common-utilities/common/ResourceDetails/ResourceDetails';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent';
import ActionButton from '../../../../shared/common-utilities/common/ActionButton';
import WindowComponent from '../../common/Window/WindowComponent';
import i18_en from '../../../../jsonStore/i18_en.json';
import { MessageComponent, RenderActionButtons } from '../../../../shared/common-utilities/common/DeleteConfirmationComponent';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService';

const entity = "driver";
let entityNameFor = "driver";
const odataApiName = "drivers";
let odataApiNameFor = "drivers";
let service = getSetDataService();
let dataService = dataStorageService();
let apiService = commonApiService();
const dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh', 'New Window'];
let gridSelectedValues = {};

const Driver = (props) => {
  //#region Reference
  const driverGrid = useRef(null);
  //#endregion Reference

  //#region Hook Selctor
  //#endregion Hook Selctor

  const driverGriddDtaItemKey = "id";
  const initialSort = service.initialSort[entity];

  //#region States - Get set variables
  const [tempDriverData, setTempDriverData] = useState([]);
  const [driverGridColumnList, setDriverGridColumnList] = useState(null);
  const [tempDriverGridColumnList, setTempDriverGridColumnList] = useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isDriver, setIsDriver] = useState(true);
  const [loadedGridData, setLoadedGridData] = useState(tempDriverData);
  const [myGridData, setmyGridData] = React.useState([]);
  const [loadSelectionValue, setloadSelectionValue] = useState(100);
  const [totalData, setTotalData] = useState(0);
  const userID = localStorage.getItem('userID');

  const driverFilterComponents = [];
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const [paramsData, setParamsData] = useState(null);
  let [initialFilter, setInitialFilter] = useState([]);
  const [nextDataUrl, setNextDataUrl] = useState(null);
  const [initialSaveViewData, setInitialSaveViewData] = useState([]);
  const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
  const [driverData, setDriverData] = useState({});
  const [driverResource, setDriverResource] = useState({});
  const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [errorSnackbarMessageDriver, setErrorSnackbarMessageDriver] = useState('');
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isResourceLoad, setIsResourceLoad] = useState(false);
  const [changeToChildDriver, setChangeToChildDriver] = useState(null);
  const [isApiCallRequired, setIsApiCallRequired] = useState(true);
  const [openConfirmationModal, setopenConfirmationModal] = useState(false);
  const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [canExecute, setCanExecute] = useState([]);

  const driverDetails = [
    { label: 'Driver Code', value: driverResource[0]?.codeDriver },
    { label: 'FirstName', value: driverResource[0]?.firstName },
    { label: 'LastName', value: driverResource[0]?.lastName },
  ];
  const metaData = JSON.parse(dataService.getLocalStorageData("metaData"))

  //#endregion States

  //#region Hooks  

  useEffect(() => {
    // setIsLoading(true);

    setIsApiLoaded(true);
    odataApiNameFor = odataApiName;
    entityNameFor = entity;
    if (props?.gridFlagVal) {
      odataApiNameFor += props?.gridFlagVal;
      entityNameFor += props?.gridFlagVal;
    }
    setTimeout(()=>{
      setGridColumns(entity);
    },100)
    let tempFilterData = [];
    let userData = service.getUserFilterData(entity);
    const mergedArray = (tempFilterData || []).concat(userData);
    setInitialFilter(mergedArray);
  }, []);

  const setGridColumns = (entityName) => {
    const columnList = localStorage.getItem(entityNameFor + 'ColumnList');
    if (!_.isNil(columnList)) {
      setDriverGridColumnList(JSON.parse(columnList));
      getColList(JSON.parse(columnList));
      return true;
    }

    if(!_.isNil(metaData) || metaData !== "undefined") {
      service.entityDefinitions(metaData, entityName).then((tempFieldList) => {
        localStorage.setItem(entityNameFor + 'ColumnList', JSON.stringify(tempFieldList));
        setDriverGridColumnList(tempFieldList);
        getColList(tempFieldList);
      })
    }
  }

  const getDefaultColList = (dcolsString, gridcolumns) => {
    if (!_.isNil(dcolsString) && dcolsString != "undefined") {
      const dCols = JSON.parse(localStorage.getItem("defaultColumnSetting"));
      const defaultColumnList = gridcolumns?.filter(item => {
        return dCols[entity]?.split("~").includes(item.field)
      });
      if (defaultColumnList.length == 0) {
        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
        setTempDriverGridColumnList(gridcolumns);
      } else {
        const sortedArr = _.sortBy(defaultColumnList, function (item) { return dCols[entity]?.split("~").indexOf(item.field) });
        localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(sortedArr));
        setTempDriverGridColumnList(sortedArr);

        const arr1 = sortedArr;
        const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
        const newsortedArr = _.concat(arr1, arr2);
        setDriverGridColumnList(newsortedArr);
      }
    } else {
      localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(gridcolumns));
      setTempDriverGridColumnList(gridcolumns);
    }
  }

  const getColList = (gridcolumns) => {
    const driverUrl = `${fetchSavedView}?$filter=(title eq '${odataApiNameFor}' and userID eq '${userID}')`;
    const dcolsStringDriver = localStorage.getItem("defaultColumnSetting");
    apiService.get(driverUrl).then(savedViewRes => {
      if (savedViewRes?.value?.length > 0) {
        apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then(readResDriver => {
          if (readResDriver !== undefined && readResDriver !== null) {
            setInitialSaveViewData(savedViewRes.value);
            setInitialFetchReadLinkData(readResDriver);
            const defaultViewExist = readResDriver[odataApiNameFor]?.savedViews?.filter(item => item.defaultView);
            if (defaultViewExist?.length > 0 && defaultViewExist?.[0]?.subviews?.length > 0) {
              setCanExecute(defaultViewExist);
              const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
              if (favFilterExist?.length > 0) {
                setTempDriverGridColumnList(defaultViewExist[0].columns);
              }
            } else if (readResDriver[odataApiNameFor]?.columns?.length !== 0) {
              localStorage.setItem(entityNameFor + 'TempColumnList', JSON.stringify(readResDriver[odataApiNameFor]?.columns));
              setTempDriverGridColumnList(readResDriver[odataApiNameFor]?.columns);
            } else {
              getDefaultColList(dcolsStringDriver, gridcolumns);
            }
          }
        })
      } else {
        getDefaultColList(dcolsStringDriver, gridcolumns);
      }

      setIsLoading(false);
    });
  }

  useEffect((e) => {
    if (!_.isNil(paramsData) && isApiCallRequired) {
      updateSendApi(loadSelectionValue);
    } else {
      setIsApiCallRequired(true);
    }
  }, [paramsData]);

  useEffect((e) => {
    if (!_.isNil(tempDriverGridColumnList)) {
      setNextDataUrl(null);
      updateSendApi(loadSelectionValue);
    }
  }, [tempDriverGridColumnList]);

  useEffect(()=>{
    if (!_.isNil(props.resourceData)) {
      const url = `${baseUrl}/drivers?&$filter=(codeDriver eq '${props?.resourceData}')`;
      apiService.get(url).then(res => {
        if (res !== null && res !== undefined) {
          setDriverResource(res.value);
          setIsResourceLoad(true);
        }
      })
    }
  },[])

  const sendApi = (val, size) => {
    let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    if (canExecute?.length > 0) {
      return;
    }
    if (tempDriverGridColumnList !== null && tempDriverGridColumnList !== undefined && tempDriverGridColumnList?.length > 0) {
      setIsLoading(true);
      const params = '&' + filter + '&' + orderby + '&$count=true';
      const columns = tempDriverGridColumnList?.map(item => item.field);
      const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
      if (!_.isNull(mandatroyEntity)) {
        let splitedColums = mandatroyEntity.mandatoryColumns.split("~");
        splitedColums.forEach(element => {
          if (!columns.includes(element)) {
            columns.push(element)
          }
        });
      }
      const selectFields = `&$select=${columns}`;
      const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
      apiService.get(getDrivers, params, `${selectFields}`, oDataNextLink, size, null).then(response => {
        if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
          if (response?.error?.message?.includes('$orderby')) {
            const sortToRemoveDriver = response.error.message.split("'")[1];
            setChangeToChildDriver({ type: "sort", value: sortToRemoveDriver });
          } else if (response?.error?.code == "Application_FilterErrorException") {
            const filterToRemoveDriver = response.error.message.split("'")[1];
            setChangeToChildDriver({ type: "filter", value: filterToRemoveDriver });
          }
        } else {
            if (response.value) {
              setTotalData(response["@odata.count"]);
              let tempData = [];
              if (val == 'Scroll' && tempDriverData !== null && tempDriverData !== undefined && tempDriverData.length > 0) {
                tempDriverData.forEach(tempDriver => {
                  tempData.push(tempDriver);
                });
                response.value.map(temp => {
                  tempData.push(temp)
                })
              }
              // Update the data based on the response
              else {
                tempData = response.value;
              }

              tempData = service.setColorCodeAndDate(tempData, driverGridColumnList);
              setIsApiLoaded(true);
              if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
                setNextDataUrl(response['@odata.nextLink']);
              }
              setmyGridData(tempData);
              setLoadedGridData(tempData);
              setTempDriverData(tempData);
            }
          }
        })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
          if (props?.sendDataToParent) {
            props.sendDataToParent(odataApiName);
          }
        });
    } else {
      setIsLoading(false);
    }
  }

  const updateSendApi = useMemo(() => {
    return _.debounce((size) => {
      sendApi(null, size);
    }, 250);
  }, [sendApi]);

  const childStateHandler = (value, flag) => {
    if (flag === 'showGridHeader') {
      setIsDriver(value);
    } else if (flag === 'getData') {
      setNextDataUrl(null);
      setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
      setIsApiCallRequired(value.isApiCall);
      setTempDriverGridColumnList(value.columns);
      setCanExecute([]);
    } else if (flag === 'refresh') {
      sendApi(null, loadSelectionValue);
    } else if (flag === 'selectedValues') {
      gridSelectedValues = value;
    } else if (flag === 'dataItem') {
      setDriverData(value);
    } else if (flag === 'columnsVisible') {
      setTempDriverGridColumnList(value);
    }
  }

  const closePopup = () => {
    props.onClose();
  }

  const onOkClick = () => {
    let transferdataId = Object.entries(gridSelectedValues).filter(([key, value]) => value === true).map(([key]) => key);
    if (transferdataId.length === 0) {
      setErrorSnackbarMessageDriver('Please select driver resource');
      setErrorSnackbarOpen(true);
      return;
    }
    props?.addResourceApi(driverData);
  }

  const deAllocateResource = () => {
    props?.addResourceApi({codeDriver:""});
  }

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackbarOpen(false);
  };

  const onLoadSelectionChangeDriver = (e) => {
    let value = e.value;
    setloadSelectionValue(value);
    sendApi(null, value);
  }

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setopenConfirmationModal(true);
  }

  const closeConfirmationModalDriver = () => {
    setopenConfirmationModal(false);
  }

  //#endregion

  return (
    <>
      {isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}
      <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }}  id={odataApiName}>

        <AlertComponent isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessageDriver} handleErrorSnackbarClose={handleErrorSnackbarClose} />
        {
          props.resourceData != null && isResourceLoad && (
            <>
              {
                driverResource.length > 0 ? (
                  <>
                    <ResourceDetails details={driverDetails} onDeallocate={() => setIsDeleteDialogOpen(true)} />
                  </>
                ) : (
                  <Typography color="#ce0000" variant="body2" sx={{fontWeight:'bold',paddingBottom:'7px',textAlign:'center'}}> Allocated Driver ({props?.resourceData}) doesn't exists!</Typography>
                )
              }
            </>
          )
        }
        {isDriver &&
          <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Driver</Typography>
          </Box>}
        <Box sx={{ p: 0, display: 'flex' }} className="filterbar-bg">
          <Grid
            item={true}
            elevation={0}
            pl={0}
            sx={{ flexGrow: 1, }}
            className='grid-movement'
            xs component={Card}
          >
            {isApiLoaded && <DataGridComponent
              {...props}
              gridRef={driverGrid}
              gridFlagVal={odataApiName}
              gridFlagValFor={odataApiNameFor}
              gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px' }}
              entity={entity}
              gridNewData={myGridData}
              loadedGridData={loadedGridData}
              tempGridData={tempDriverData}
              gridColumnList={driverGridColumnList ? driverGridColumnList : []}
              gridTempColumnList={tempDriverGridColumnList ? tempDriverGridColumnList : []}
              isItemVisible={false}
              isShowGridHeader={isDriver}
              griddDtaItemKey={driverGriddDtaItemKey}
              gridSort={initialSort}
              gridInitialFilter={initialFilter}
              gridDraggable={false}
              sendDataToParent={childStateHandler}
              gridDataAction={dataRelatedAction}
              gridFilterComponents={driverFilterComponents}
              onLoadSelectionChange={onLoadSelectionChangeDriver}
              loadSelectionValue={loadSelectionValue}
              gridtotalData={totalData}
              initialSaveViewData={initialSaveViewData}
              initialFetchReadLinkData={initialFetchReadLinkData}
              selectableMode={"single"}
              changeToChild={changeToChildDriver}
            />}
          </Grid>
        </Box>
      </Grid>
      {isDeleteDialogOpen && <WindowComponent title={i18_en.confirmDeallocateRes} visible={isDeleteDialogOpen} initialWidth={400} initialHeight={200} minWidth={400} minHeight={200} onClose={() => setIsDeleteDialogOpen(false)} dataComponent={MessageComponent} actionButtons={<RenderActionButtons onClose={() => setIsDeleteDialogOpen(false)} onConfirm={deAllocateResource}/>} resizable={false} minimizeButton={() => { return null }} maximizeButton={() => { return null }} doubleClickStageChange={false}/>}
      {
        props?.openAddColumnModal && (
          <ActionButton onOkClick={onOkClick} closePopup={closePopup}/>
        )
      }
      <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModalDriver} />
    </>
  )
};

export default Driver;